/* template */
<template><es-popup :show="(show)" position="bottom" closeable @close="closePopup"><div class="main" v-if="(currentItem?.status_name)"><div class="title"><hl-text :text="(title)" :commonStyle="(commonStyle)" :hlStyle="(hlStyle)"/></div><div class="sub-title">抢票失败，全额退款</div><div class="package-select"><template v-for="(item, index) in (list)"><mpx-view :class="({'active': currentIndex === index,'disabled': item.disable == 1})" @tap="handleClick(item,index)" class="package-select-item" v-if="(index)"><div class="item-title">{{item.status_name}}</div><div class="item-price" v-if="(item.status && item.disable == 0)"><div class="item-price-after">¥{{item.show_price}}</div><div class="item-price-before" v-if="(item.amount)">¥{{item.price}}</div></div><div class="active-wrap"><mpx-image :src="(activeIcon)" class="active-image" v-if="(currentIndex === index)"></mpx-image></div></mpx-view></template></div><div class="tips"><hl-text :text="(tipsText)" :commonStyle="(tipsCommonStyle)" :hlStyle="(tipsHlStyle)"/></div><div class="footer"><mpx-view @tap="submit" class="btn">确认使用 ¥{{currentItem.show_price}}</mpx-view></div></div></es-popup></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1868e15d"}'>
.main
  padding-bottom 40px
  border-radius 12px 12px 0 0
  overflow hidden
  background: linear-gradient(103deg, #FFF5EE 2%, #E5F9F6 89%);
  .title
    margin 18px 0 0 20px
  .sub-title
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 12px;
    letter-spacing: 0px;
    color: #666666;
    margin 9px 0 0 20px
  .package-select
    margin-top 24px
    padding 0px 20px
    display grid
    grid-template-rows: auto auto
    grid-template-columns: repeat(3, 1fr)
    grid-template-areas: "A1 A2 A3" "A4 A5 A5"
    grid-gap 9px 8px
    .package-select-item
      font-family PingFang SC
      height 48px
      border-radius 8px
      opacity 1
      background #FFFFFF
      border 0.5px solid #D1DBE9
      backdrop-filter blur(27.2px)
      display flex
      flex-direction column
      justify-content center
      align-items center
      position relative
      &:last-child
        grid-area A5
        border: 0.5px solid rgba(120, 62, 23, 0.2);
        .item-title
            color #783E17
          .item-price
            .item-price-after
              color rgba(120, 62, 23, 0.9)
            .item-price-before
              color rgba(120, 62, 23, 0.5)
        .active-wrap
          background linear-gradient(143deg, #DC9626 -64%, #F9CD87 84%)
      &:last-child.active
        background: linear-gradient(168deg, #FEF9F2 8%, #FFF1DB 136%)
        border: 1px solid #F9CD87
      &:last-child::after
        content ''
        position absolute
        width 45px
        height 38px
        right 0px
        bottom 0px
        background-image url("https://ut-static.udache.com/webx/sfc/U4JbSF20KzyMjnBAQP2FD.png")
        background-size 100% 100%
        border-radius 0 0 8px 0
      .item-title
        font-family 'PingFang SC'
        font-size 14px
        font-weight 500
        line-height 14px
        text-align center
        letter-spacing 0px
        color #333333
      .item-price
        display flex
        flex-direction row
        margin-top 3px
        align-items baseline
        .item-price-after
          font-family 'PingFang SC'
          font-size 12px
          font-weight normal
          line-height 12px
          text-align center
          letter-spacing 0px
          margin-right 3px
          color #666666
        .item-price-before
          font-family 'PingFang SC'
          font-size 9px
          font-weight normal
          line-height 9px
          text-align right
          letter-spacing 0px
          color #999999
          text-decoration line-through
    .active
      background #FEF9F4
      box-sizing border-box
      border 1px solid #FF5900
      .item-price
        .item-price-after
          color #333333
      .active-wrap
        position absolute
        height 11px
        width 15px
        right -1px
        bottom -1px
        background #FF6400
        border-radius 8px 0
      .active-image
          width 5.5px
          height 4px
          position absolute
          right 3.5px
          bottom 2.5px
          z-index 2
    .disabled
      background linear-gradient(0deg, #E9EFF3, #E9EFF3)
      .item-title
        color #999999
  .tips
    margin 18px 0 0 20px
  .footer
    display flex
    align-items center
    justify-content center
    margin 12px 20px 0 20px
    .btn
      flex 1
      height: 50px;
      border-radius: 8px;
      background: #FF5900;
      color: #FFFFFF;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 50px;
      text-align center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1868e15d"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./packages-popup.mpx.js?isComponent&outputPath=components%2Fpackages-popup1868e15d%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./packages-popup.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpackages-popup1868e15d%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1868e15d"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/packages-popup1868e15d/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-button':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-popup':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'hl-text':getComponent(require("../../../components/hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'es-overlay':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/overlay/index.mpx?isComponent&outputPath=components%2Findex3774078c%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
